import { render, staticRenderFns } from "./ModalResources.vue?vue&type=template&id=17f6106e&scoped=true"
import script from "./ModalResources.vue?vue&type=script&lang=js"
export * from "./ModalResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f6106e",
  null
  
)

export default component.exports